module.exports = __webpack_public_path__ + "img/Wiederschaukeln.cc170455.svg";